export const IconCrossFalse: {
  name: 'icon_cross_false-6090ed824087'
} = {
  name: 'icon_cross_false-6090ed824087'
}
